"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalLoadContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var bgMap = {
    default: "#111d2c",
    danger: "#FF4D4F",
};
var StyledModal = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-modal-header {\n    background: ", " !important;\n\n    .ant-modal-title {\n      color: #ffffff !important;\n    }\n  }\n\n  .ant-modal-close {\n    .ant-modal-close-icon {\n      color: #ffffff !important;\n    }\n  }\n\n  .ant-modal-body {\n    ", "\n  }\n  ", "\n"], ["\n  .ant-modal-header {\n    background: ", " !important;\n\n    .ant-modal-title {\n      color: #ffffff !important;\n    }\n  }\n\n  .ant-modal-close {\n    .ant-modal-close-icon {\n      color: #ffffff !important;\n    }\n  }\n\n  .ant-modal-body {\n    ",
    "\n  }\n  ", "\n"])), function (_a) {
    var _b = _a.$variant, $variant = _b === void 0 ? "default" : _b;
    return bgMap[$variant];
}, function (_a) {
    var $isFullScreen = _a.$isFullScreen, $isWithFooter = _a.$isWithFooter;
    return $isFullScreen
        ? "\n      height: calc(100vh - " + ($isWithFooter ? "100" : "55") + "px);\n      overflow: hidden;\n    "
        : "";
}, function (_a) {
    var _b = _a.$styles, $styles = _b === void 0 ? "" : _b;
    return $styles;
});
exports.ModalLoadContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  left: 50%;\n  top: 50%;\n\n  .ant-modal-body {\n    height: 250px !important;\n  }\n"], ["\n  width: 100%;\n  left: 50%;\n  top: 50%;\n\n  .ant-modal-body {\n    height: 250px !important;\n  }\n"])));
exports.default = StyledModal;
var templateObject_1, templateObject_2;
